"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconTruckDryvan = function SvgIconTruckDryvan(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "truck dryvan icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Truck Dryvan Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M33.09 24v-4.667h4.546L41.206 24zm1.818 12.137c-1.508 0-2.728-1.257-2.728-2.8 0-1.55 1.22-2.799 2.728-2.799 1.506 0 2.728 1.249 2.728 2.8 0 1.542-1.222 2.8-2.728 2.8zm-21.818 0c-1.506 0-2.728-1.257-2.728-2.8 0-1.55 1.222-2.799 2.728-2.799 1.504 0 2.728 1.249 2.728 2.8 0 1.542-1.224 2.8-2.728 2.8zM38.546 16.53h-8.138v11.368h-1.902V9.063H7.636C5.626 9.063 4 10.729 4 12.797v20.54h3.636c0 3.09 2.442 5.6 5.454 5.6 3.012 0 5.456-2.51 5.456-5.6h10.908c0 3.09 2.44 5.6 5.454 5.6 3.012 0 5.454-2.51 5.454-5.6H44V24z"
  }));
};

var _default = SvgIconTruckDryvan;
exports.default = _default;